import { ComponentType, LazyExoticComponent } from "react";
import { UserRole } from "../../types";
import { Routes } from "../route";
import { addDonationsPage, AddEditMemberPage, AddEditNGOPage, CampaignAddEditPage, CampaignPage, CategoriesPage, CitiesPage, CreateOrganizationPage, donationsFollowUpPage, donationsPage, MemberPage, MyDonationPage, NgoDashboard, NGOsTablePageAdmin, NGOsTablePageOrg, OrganizationDashboardPage, OrganizationListPage, organizationMemberPage, ProjectList, reportPage, ResetPasswordPage, SettingPage, SuperAdminDashboardPage, UpdateOrganizationPage, UserSettingPage } from "./RoutePages";

interface RouteConfig {
  path: string;
  element: LazyExoticComponent<ComponentType<any>>;
  roles: UserRole[];
  index?: boolean;
}

export const RoutesConfig: RouteConfig[] = [
  // SUPER_ADMIN ROUTES
  {
    path: Routes.ADMIN_DASHBOARD,
    element: SuperAdminDashboardPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_ORGANIZATIONS,
    element: OrganizationListPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_ORGANIZATIONS_ADD,
    element: CreateOrganizationPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_ORGANIZATIONS_UPDATE,
    element: UpdateOrganizationPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_CITY_LIST,
    element: CitiesPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_NGO_LIST,
    element: NGOsTablePageAdmin,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_NGO_ADD,
    element: AddEditNGOPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.ADMIN_NGO_EDIT,
    element: AddEditNGOPage,
    roles: [UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.RESET_PASSWORD,
    element: ResetPasswordPage,
    roles: [],
  },
  // {
  //   path: Routes.ADMIN_CAMPAIGN_LIST,
  //   element: CampaignPage,
  //   roles: [UserRole.SUPER_ADMIN],
  // },
  // {
  //   path: Routes.ADMIN_CAMPAIGN_EDIT,
  //   element: CampaignAddEditPage,
  //   roles: [UserRole.SUPER_ADMIN],
  // },
  // {
  //   path: Routes.ADMIN_CAMPAIGN_ADD,
  //   element: CampaignAddEditPage,
  //   roles: [UserRole.SUPER_ADMIN],
  // },
  {
    path: Routes.ADMIN_CATEGORY,
    element: CategoriesPage,
    roles: [UserRole.SUPER_ADMIN],
  },

  // ORGANIZATION ADMIN ROUTES
  {
    path: Routes.ORG_DASHBOARD,
    element: OrganizationDashboardPage,
    roles: [UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.ORG_CAMPAIGN_EDIT,
    element: CampaignAddEditPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
  },
  {
    path: Routes.ORG_CAMPAIGN_ADD,
    element: CampaignAddEditPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
  },
  {
    path: Routes.ORG_CAMPAIGN,
    element: CampaignPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
  },
  // {
  //   path: Routes.ORG_CITIES,
  //   element: OrganizationCitiesPage,
  //   roles: [UserRole.SUPER_ADMIN],
  // },
  {
    path: Routes.ORG_NGOS,
    element: NGOsTablePageOrg,
    roles: [UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.ORG_SETTINGS,
    element: SettingPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
  },
  {
    path: Routes.USER_SETTINGS,
    element: UserSettingPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER, UserRole.DONOR],
  },
  {
    path: Routes.ORG_NGO_ADD,
    element: AddEditNGOPage,
    roles: [UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.ORG_NGO_EDIT,
    element: AddEditNGOPage,
    roles: [UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.MEMBERS,
    element: MemberPage,
    roles: [UserRole.NGO_MEMBER, UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.ADD_MEMBERS,
    element: AddEditMemberPage,
    roles: [],
  },
  {
    path: Routes.EDIT_MEMBERS,
    element: AddEditMemberPage,
    roles: [],
  },
  {
    path: Routes.ORG_MEMBER,
    element: organizationMemberPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER],
  },

  //ngo
  {
    path: Routes.ORG_DASHBOARD,
    element: NgoDashboard,
    roles: [UserRole.NGO_MEMBER, UserRole.ORGANIZATION_MEMBER],
  },


  //projects
  {
    path: Routes.ORG_PROJECT,
    element: ProjectList,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER, UserRole.SUPER_ADMIN],
  },

  //donations
  {
    path: Routes.DONATIONS,
    element: donationsPage,
    roles: [UserRole.ORGANIZATION_MEMBER, UserRole.NGO_MEMBER, UserRole.SUPER_ADMIN],
  },
  {
    path: Routes.EDIT_DONATION,
    element: donationsFollowUpPage,
    roles: [UserRole.NGO_MEMBER, UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.ADD_DONATIONS,
    element: addDonationsPage,
    roles: [UserRole.NGO_MEMBER, UserRole.ORGANIZATION_MEMBER],
  },
  {
    path: Routes.EDIT_DONATION,
    element: donationsFollowUpPage,
    roles: [UserRole.NGO_MEMBER, UserRole.ORGANIZATION_MEMBER],
  },

  //Report
  {
    path: Routes.ORG_REPORT,
    element: reportPage,
    roles: [UserRole.NGO_MEMBER, UserRole.ORGANIZATION_MEMBER],
  },

  //donor
  {
    path: Routes.MY_DONATION,
    element: MyDonationPage,
    roles: [UserRole.DONOR],
  },
];
